// extracted by mini-css-extract-plugin
export default {"loadRing":"BusySpinner_loadRing__8axSm"};